import { categories } from '../../../mocks/guaData';

export default function CategoryZone() {
  return (
    <section id="category" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-xs font-bold uppercase tracking-widest text-accent-600">Explore Categories</p>
          <h3 className="mt-2 text-2xl font-black text-foreground-950 md:text-3xl">热门栏目</h3>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            按类型为你整理反差名场面与爆点热闻，选一个感兴趣的栏目开吃
          </p>
        </div>

        <div className="mt-9 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {categories.map((c) => (
            <a
              key={c.key}
              href="#feeds"
              className="group flex flex-col items-center gap-3 rounded-2xl border border-background-200 bg-background-50 p-5 text-center transition hover:-translate-y-1 hover:border-primary-200 hover:shadow-soft"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-100 text-2xl text-primary-600 transition group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={c.icon} aria-hidden="true"></i>
              </span>
              <span className="font-bold text-foreground-900">{c.key}</span>
              <span className="text-xs leading-snug text-foreground-500">{c.desc}</span>
              <span className="mt-1 inline-flex items-center gap-1 text-xs font-semibold text-accent-600">
                去看看
                <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}